import {
	Container,
	ContainerPadding,
	Text,
	TokenTextAppearance,
	Image,
	TextAlignment,
	AspectRatioContainer,
	CTA,
	Spinner,
	ContainerGutter,
	TokenTextColor,
	Layout,
	Breakpoints,
	styled,
	LayoutRowGap,
	Select,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { TelefonoInput } from '../../../oneform/components/telefono-input';
import { PersonBenefits } from '@esportal/portal-service';
import { LaLigaParticipado } from './laLigaParticipado';
import { PortalContext } from '../../../../context/portal-context';
import { useErrorAlert } from '../../../../hooks/use-error-alert';
import { useTrackingManager } from '../../../../tracking/use-tracking-manager';
import { getParamsClubVW } from '../../../../helpers/get-params-clubvw';
import { DefaultPromotionData } from '../../promotion-popup-layer';

const StyledContainer = styled(Container)`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 12px;
	width: 100%;
	min-height: 220px;
	border: 1px solid #001e50;
	border-radius: 24px;
	background: #ffffff;
	padding: 24px;
`;

const StyledIcon = styled(Container)`
	padding-top: --var(--dynamic100);
`;

interface LaLigaForm {
	name: string;
	data: DefaultPromotionData & {
		equipo: string;
	};
}
export const LaLigaParticipa: React.FC = () => {
	const { portalService } = React.useContext(PortalContext);
	const { device, tc, url } = getParamsClubVW();
	const trackingManager = useTrackingManager();
	const [participando, setParticipando] = React.useState<boolean>(false);
	const [estadoParticipacion, setEstadoParticipacion] = React.useState<'participa' | 'participado'>('participa');
	const [phoneData, setPhoneData] = React.useState({ prefix: '+34', phoneNumber: '' });
	const [selectedTeam, setSelectedTeam] = React.useState('');
	const { showAlert } = useErrorAlert();

	const promotionName = 'LaLigaLanzamiento2026';

	React.useEffect(() => {
		trackingManager.trackClubVWFormLoad(
			{
				FormName: 'vw-club-LaLigaLanzamiento2026-enroll',
				FormStart: true,
				FormTypeMultiple: ['registration'],
			},
			{ contentId: 'vw-club-LaLigaLanzamiento2026-enroll' },
			{ vehicle: [] },
		);
	}, []);

	const handleParticipate = () => {
		const participateData: LaLigaForm = {
			name: promotionName,
			data: {
				phonePrefix: phoneData.prefix,
				phoneMobile: phoneData.phoneNumber,
				originDeviceType: device,
				originTrackingCode: tc,
				formUrl: url,
				equipo: selectedTeam,
			},
		};

		setParticipando(true);

		portalService.postParticipate(participateData).subscribe({
			next: (response: PersonBenefits | null) => {
				setParticipando(false);

				if (response !== null && response.benefits.promotions) {
					const responsePromotion = response.benefits.promotions.find((p) => p.name === promotionName);
					if (responsePromotion?.contestant) {
						setEstadoParticipacion('participado');
						trackingManager.trackClubVWFormSubmissionSuccessMessageLoad(
							{
								FormName: 'vw-club-LaLigaLanzamiento2026-enroll',
								FormStart: false,
								FormTypeMultiple: ['registration'],
							},
							{ contentId: 'vw-club-LaLigaLanzamiento2026-enroll' },
							{ vehicle: [] },
						);
					}
				} else {
					showAlert();
				}
			},
			error: () => {
				setParticipando(false);
				showAlert();
			},
		});
	};

	if (estadoParticipacion === 'participado') {
		return <LaLigaParticipado />;
	}

	const isFormValid = phoneData.phoneNumber.trim() !== '' && selectedTeam.trim() !== '';

	return (
		<Container
			padding={{
				right: ContainerPadding.dynamic0100,
				bottom: ContainerPadding.dynamic0100,
				left: ContainerPadding.dynamic0100,
			}}
			horizontalAlign={'center'}
			wrap={'always'}
		>
			<AspectRatioContainer data-testid="aspect-ratio-container" ratio="2:1">
				<Image
					src={
						'https://assets.volkswagen.com/is/image/volkswagenag/alerta_v2?Zml0PWNyb3AlMkMxJndpZD0xNjAwJmhlaT0xMjAwJmZtdD1qcGVnJnFsdD03OSZiZmM9b2ZmJmM3MWE='
					}
					alt="Imagen La Liga"
					style={{ borderRadius: '16px', objectFit: 'cover' }}
				/>
			</AspectRatioContainer>
			<Container
				wrap={'always'}
				padding={{
					top: ContainerPadding.dynamic0130,
				}}
			>
				<Text appearance={TokenTextAppearance.headline300} textAlign={TextAlignment.center}>
					<Text bold>Grita “gooool” con este sorteo especial de LALIGA</Text>
				</Text>

				<Container
					wrap={'always'}
					padding={{
						top: ContainerPadding.dynamic0130,
						left: ContainerPadding.dynamic0100,
						right: ContainerPadding.dynamic0100,
					}}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<Text appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center} bold>
						Como orgulloso patrocinador de la afición, junto a LALIGA, te traemos un sorteo único en el que podrás
						participar para ganar uno de estos premios:{' '}
					</Text>
				</Container>

				<Container
					wrap={'always'}
					padding={{
						top: ContainerPadding.dynamic0100,
					}}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<Layout
						data-testid="laLigaParticipa__layout"
						appearance={{
							[Breakpoints.default]: [
								{ name: '.', columns: 1 },
								{ name: 'a', columns: 22 },
								{ name: '.', columns: 1 },
								{ name: '.', columns: 1 },
								{ name: 'b', columns: 22 },
								{ name: '.', columns: 1 },
							],
							[Breakpoints.b960]: [
								{ name: '.', columns: 1 },
								{ name: 'a', columns: 10 },
								{ name: '.', columns: 2 },
								{ name: 'b', columns: 10 },
								{ name: '.', columns: 1 },
							],
						}}
						rowGap={LayoutRowGap.dynamic0200}
						allowOverflowingContent
					>
						<StyledContainer>
							<Text textAlign={TextAlignment.center}>
								<Text textAlign={TextAlignment.center} appearance={TokenTextAppearance.headline300} bold>
									CAMISETA OFICIAL DE LALIGA EA SPORTS
									<br />
									<br />
								</Text>
								<StyledIcon>
									<Image
										src={
											'https://assets.volkswagen.com/is/image/volkswagenag/Frame%20633924?Zml0PWNyb3AlMkMxJndpZD03ODAmaGVpPTMwMCZmbXQ9anBlZyZxbHQ9NzkmYmZjPW9mZiYyYTNh'
										}
										alt="Gif LaLiga"
										style={{ borderRadius: '16px', objectFit: 'cover' }}
									/>
								</StyledIcon>
								<br />
								<b>Una camiseta oficial de tu equipo</b> para seguir apoyándolos como has hecho todo este tiempo.
							</Text>
						</StyledContainer>
						<StyledContainer>
							<Text textAlign={TextAlignment.center}>
								<Text textAlign={TextAlignment.center} bold appearance={TokenTextAppearance.headline300}>
									PACK DE BALÓN Y BUFANDA OFICIAL <br />
									<br />
								</Text>
								<StyledIcon>
									<Image
										src={
											'https://assets.volkswagen.com/is/image/volkswagenag/Capa_1?Zml0PWNyb3AlMkMxJndpZD03NzcmaGVpPTI0NiZmbXQ9anBlZyZxbHQ9NzkmYmZjPW9mZiZhNmE3'
										}
										alt="Gif LaLiga"
										style={{ borderRadius: '16px', objectFit: 'cover' }}
									/>
								</StyledIcon>
								<br />
								Un <b>Balón Oficial Puma de LALIGA</b> y una{' '}
								<b>bufanda oficial de tu equipo favorito de LALIGA EA SPORTS</b> para celebrar cada gol como se merece.
							</Text>
						</StyledContainer>
					</Layout>
				</Container>
				<Container
					wrap={'always'}
					padding={{
						top: ContainerPadding.dynamic0100,
					}}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<Text appearance={TokenTextAppearance.copy100} textAlign={TextAlignment.center}>
						Hay 5 <b>camisetas oficiales</b> y 15 <b>packs de balón y bufanda oficial</b> disponibles.
					</Text>
				</Container>

				<Container
					padding={{
						top: ContainerPadding.static300,
					}}
					gutter={ContainerGutter.dynamic0100}
					wrap={'always'}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<Text bold appearance={TokenTextAppearance.bigcopy200} textAlign={TextAlignment.center}>
						Para participar, solo necesitas responder:{' '}
					</Text>
					<Container stretchContent>
						<Layout
							data-testid="laLigaParticipa__layout"
							appearance={{
								[Breakpoints.default]: [
									{ name: '.', columns: 1 },
									{ name: 'a', columns: 22 },
									{ name: '.', columns: 1 },
									{ name: '.', columns: 1 },
									{ name: 'b', columns: 22 },
									{ name: '.', columns: 1 },
								],
								[Breakpoints.b960]: [
									{ name: '.', columns: 1 },
									{ name: 'a', columns: 10 },
									{ name: '.', columns: 2 },
									{ name: 'b', columns: 10 },
									{ name: '.', columns: 1 },
								],
							}}
							rowGap={LayoutRowGap.dynamic0200}
							allowOverflowingContent
						>
							<Container stretchContent>
								<Text textAlign={TextAlignment.center}>
									¿Cuál es el equipo que hace que grites de emoción hasta quedarte sin voz?
								</Text>
								<Container
									stretchContent
									padding={{
										top: ContainerPadding.static200,
										left: ContainerPadding.static100,
										right: ContainerPadding.static100,
										bottom: ContainerPadding.static100,
									}}
								>
									<Select
										label="Equipo*"
										value={selectedTeam}
										onChange={(event: React.SyntheticEvent<HTMLSelectElement>) =>
											setSelectedTeam(event.currentTarget.value)
										}
										isFloating
									>
										<option value="" disabled>
											Equipo
										</option>
										<option value="Athletic Club">Athletic Club</option>
										<option value="Atlético de Madrid">Atlético de Madrid</option>
										<option value="CA Osasuna">CA Osasuna</option>
										<option value="Celta">Celta</option>
										<option value="Deportivo Alavés">Deportivo Alavés</option>
										<option value="Elche CF">Elche CF</option>
										<option value="FC Barcelona">FC Barcelona</option>
										<option value="Getafe CF">Getafe CF</option>
										<option value="Girona CF">Girona CF</option>
										<option value="Levante UD">Levante UD</option>
										<option value="Rayo Vallecano">Rayo Vallecano</option>
										<option value="RCD Espanyol de Barcelona">RCD Espanyol de Barcelona</option>
										<option value="RCD Mallorca">RCD Mallorca</option>
										<option value="Real Betis">Real Betis</option>
										<option value="Real Madrid">Real Madrid</option>
										<option value="Real Oviedo">Real Oviedo</option>
										<option value="Real Sociedad">Real Sociedad</option>
										<option value="Sevilla FC">Sevilla FC</option>
										<option value="Valencia CF">Valencia CF</option>
										<option value="Villarreal CF">Villarreal CF</option>
									</Select>
								</Container>
							</Container>
							<Container stretchContent>
								<Text textAlign={TextAlignment.center}>
									Si el marcador nos dice que tú has ganado, ¿a qué número te llamamos?
								</Text>
								<Container
									padding={{
										top: ContainerPadding.static200,
										left: ContainerPadding.static100,
										right: ContainerPadding.static100,
									}}
									stretchContent
								>
									<TelefonoInput
										prefix={phoneData.prefix}
										phoneNumber={phoneData.phoneNumber}
										onChange={(data) => setPhoneData(data)}
										required
									/>
								</Container>
							</Container>
						</Layout>
					</Container>
				</Container>
				<Container
					padding={{
						top: ContainerPadding.dynamic0050,
						bottom: ContainerPadding.dynamic0050,
					}}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<CTA
						tag="button"
						aria-label="CTA vouchers redirect"
						size="large"
						disabled={participando || !isFormValid}
						icon={participando ? <Spinner /> : undefined}
						onClick={() => handleParticipate()}
					>
						<Text bold> {participando ? '' : '¡Participa!'}</Text>
					</CTA>
				</Container>

				<Container
					gutter={ContainerGutter.dynamic0100}
					wrap={'always'}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<Text appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center}>
						¡Que no se te escapen! <b>Tienes hasta el 29 de abril</b>.
					</Text>
				</Container>

				<Container
					wrap={'always'}
					padding={{
						top: ContainerPadding.dynamic0100,
						bottom: ContainerPadding.dynamic0100,
					}}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<Text
						appearance={TokenTextAppearance.copy100}
						color={TokenTextColor.secondary}
						textAlign={TextAlignment.center}
					>
						{'Consulta las  '}
						<CTA
							tag="a"
							aria-label="CTA bases legales"
							size="large"
							emphasis="tertiary"
							onClick={() => {
								window.open(
									'https://www.volkswagen.es/idhub/content/dam/onehub_pkw/importers/es/pdf/Bases-Legales-Promocion-CLUBVWLALIGA_GOOOOL.pdf',
									'_blank',
								);
							}}
						>
							<Text>bases legales de la promoción </Text>
						</CTA>
						{'\u0020para más información.'}
					</Text>
				</Container>
			</Container>
		</Container>
	);
};
